'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HelpButton = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _buttons = require('@sitebase/ui-kit/es/buttons');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HelpButton = exports.HelpButton = function HelpButton(_ref) {
  var icon = _ref.icon,
      text = _ref.text,
      testId = _ref.testId,
      onClick = _ref.onClick;
  return _react2.default.createElement(
    _buttons.Button,
    { outfit: 'expanded large white', onClick: onClick, 'data-test-id': testId, className: 'qd-help-button' },
    _react2.default.createElement(
      'div',
      { className: 'qd-help-button__content' },
      icon,
      ' ',
      _react2.default.createElement(
        'span',
        { className: 'qd-help-button__description' },
        text
      )
    )
  );
};

exports.default = HelpButton;